import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  appuser: any = null;

  constructor(public router: Router, public service: DashboardService, private dialog: MatDialog) {
    this.appuser = this.service.currentUser();
    if (!this.appuser) { this.router.navigate(['']); }
  }

  ngOnInit() { }

  // ── Derived display helpers ──────────────────────────────────────────────

  get displayName(): string {
    if (!this.appuser) { return ''; }
    var first = this.appuser.first_name || '';
    var last  = this.appuser.last_name  || '';
    return (first + (last ? ' ' + last : '')).trim() || this.appuser.email || '';
  }

  get initials(): string {
    if (!this.appuser) { return '?'; }
    var first = (this.appuser.first_name || '').trim();
    var last  = (this.appuser.last_name  || '').trim();
    if (first && last) { return (first.charAt(0) + last.charAt(0)).toUpperCase(); }
    if (first)         { return first.charAt(0).toUpperCase(); }
    return '?';
  }

  get roleLabel(): string {
    if (!this.appuser) { return ''; }
    var roleMap: { [key: string]: string } = {
      'ADMIN':        'Administrator',
      'agent':        'Intermediary',
      'broker-admin': 'Broker Admin',
      'broker-user':  'Broker User',
      'client':       'Client'
    };
    return roleMap[this.appuser.role] || (this.appuser.role || '');
  }

  // ── Navigation ───────────────────────────────────────────────────────────

  userprofile() { this.router.navigate(['profile']); }

  // ── Logout ───────────────────────────────────────────────────────────────

  logout() {
    var name = this.appuser ? (this.appuser.first_name || 'there') : 'there';

    swal.fire({
      html: `
        <div class="holl-logout-wrap">
          <div class="holl-logout-icon">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="24" fill="#ede4f5"/>
              <path d="M20 15h-4a2 2 0 00-2 2v14a2 2 0 002 2h4" stroke="#6B2D8B" stroke-width="2" stroke-linecap="round"/>
              <path d="M31 29l4-5-4-5" stroke="#F05B24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M35 24H22" stroke="#F05B24" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </div>
          <h2 class="holl-logout-title">Sign out</h2>
          <p class="holl-logout-msg">Hey <strong>${name}</strong>, are you sure you want to sign out of your session?</p>
        </div>`,
      showCancelButton: true,
      confirmButtonText: 'Yes, sign out',
      cancelButtonText:  'Stay logged in',
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        popup:         'holl-logout-popup',
        confirmButton: 'holl-logout-confirm',
        cancelButton:  'holl-logout-cancel',
        actions:       'holl-logout-actions'
      },
      buttonsStyling: false,
      showClass:  { popup: 'holl-swal-in'  },
      hideClass:  { popup: 'holl-swal-out' }
    }).then((result) => {
      if (result.value) {
        window.localStorage.clear();
        this.router.navigate(['']);
      }
    });
  }
}
